import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  OvernightPackageRoomExtra,
  PackagesFormValues,
} from '@common/features/DynamicPackagesConfigurationWizard/types';

import { PerDate } from './PerDate';
import { PerDateRange } from './PerDateRange';
import { PerDateTime } from './PerDateTime';
import { PerDateTimeRange } from './PerDateTimeRange';
import { PerTimeRange } from './PerTimeRange';

export const controlTypes = (index: number, extra: OvernightPackageRoomExtra) => {
  const renderFunction =
    {
      per_date: (field) => <PerDate {...field} {...extra} />,
      per_date_time: (field) => <PerDateTime {...field} {...extra} />,
      per_time_range: (field) => <PerTimeRange {...field} {...extra} />,
      per_date_range: (field) => <PerDateRange {...field} {...extra} />,
      per_date_time_range: (field) => <PerDateTimeRange {...field} {...extra} />,
    }[extra.type] || (() => null);

  return <ControlType index={index} render={renderFunction} />;
};

const ControlType: React.FC<{ index: number; render: (field) => JSX.Element }> = ({
  index,
  render,
}) => {
  const { control } = useFormContext<PackagesFormValues>();

  return (
    <Controller
      name={`extras.${index}.option`}
      control={control}
      render={({ field }) => render({ field })}
    />
  );
};
